module.exports = __webpack_public_path__ + "static/img/Clayton_Oliver_desktop.516ac91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Clayton_Oliver_desktop.jpg
// module id = Di0X
// module chunks = 0